import { Controller } from '@hotwired/stimulus'
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["inputElement"]

  connect() {
    this.loadFlatpickrStylesheet()

    let originalDate = null
    let newDatePicked = false

    this.followUpDateFlatpicker = flatpickr(this.inputElementTarget, {
      dateFormat: 'M j, Y',
      onOpen: function() {
        originalDate = this.selectedDates[0]
        this.setDate(new Date())
      },
      onChange: function() {
        newDatePicked = true
      },
      onClose: function() {
        setTimeout(() => {
          if (!newDatePicked && originalDate) {
            this.setDate(originalDate)
          }
          newDatePicked = false
        }, 100)
      }
    })
  }

  loadFlatpickrStylesheet() {
    if (!document.querySelector("#flatpickr-stylesheet")) {
      let link = document.createElement('link');
      link.id = 'flatpickr-stylesheet';
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css';
      document.head.appendChild(link);
    }
  }

  onToggleFollowUpDateContainer(e) {
    this.followUpDateFlatpicker.toggle()
  }

  onClear(e) {
    this.followUpDateFlatpicker.clear()
  }

}